import { render, staticRenderFns } from "./ContactCard.vue?vue&type=template&id=3e55ed31&scoped=true&"
import script from "./ContactCard.vue?vue&type=script&lang=ts&"
export * from "./ContactCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e55ed31",
  null
  
)

export default component.exports